/* eslint no-use-before-define: 0, no-unused-expressions: 0 */
const Restrictions = require('./restrictions');

const _ = require('lodash');
/*:: type ageItem = {
  category: string,
  percentage: number
}*/

/*:: type genderBreakdownItem = {
  female: number;
  male: number;
};*/

/*:: type breakdown = {
  total: ?number,
  genderBreakdown: ?genderBreakdownItem,
  ageSeries: ?Array<ageItem>
};*/

/*:: type timeElement = {
  reach: number,
  response: number,
  action: number,
  timeStamp: number
};*/


const trimTimeSeries = timeSeries => {
  if (!(timeSeries && timeSeries.length)) return timeSeries;
  const firstNonZeroElement = timeSeries.find(({
    reach,
    response,
    action
  }) => !!(reach || response || action));
  const firstIndex = Math.max(timeSeries.indexOf(firstNonZeroElement) - 1, 0);
  return timeSeries.slice(firstIndex);
};

class Stats {
  /*:: static fromJson: (Object) => Stats */
  constructor(initObj
  /*: Object*/
  ) {
    this.reach = initObj.reach;
    this.response = initObj.response;
    this.action = initObj.action;
    this.activity = initObj.activity;
    this.earned = initObj.earned;
    this.used = initObj.used;
    this.timeSeries = initObj.timeSeries;
    this.restrictions = initObj.restrictions;
  }

  trimStart()
  /*: Stats*/
  {
    return new Stats({
      reach: this.reach,
      response: this.response,
      action: this.action,
      activity: this.activity,
      earned: this.earned,
      used: this.used,
      timeSeries: trimTimeSeries(this.timeSeries),
      restrictions: this.restrictions
    });
  }

}

Stats.fromJson = (json
/*: Object*/
) => new Stats({
  reach: parseBreakdown('reach', json),
  response: parseBreakdown('response', json),
  action: parseBreakdown('action', json),
  activity: parseBreakdown('activity', json),
  earned: parseBreakdown('earned', json),
  used: parseBreakdown('used', json),
  timeSeries: parseTimeSeries(json),
  restrictions: parseRestrictions(json)
});

function parseBreakdown(key
/*: string*/
, data
/*: Object*/
)
/*: ?breakdown*/
{
  const actionType = _.get(data, `totals[${key}]`);

  if (!actionType) return null;

  const total = _.get(actionType, 'events.sum');

  const genderBreakdown = getGenderBreakdown(actionType.gender);
  const ageSeries = getAgeSeries(actionType.ageRange);
  return {
    total,
    genderBreakdown,
    ageSeries
  };
}

function getGenderBreakdown(genderJson
/*: Object*/
)
/*: ?{ female: number, male: number }*/
{
  if (!genderJson) return null;

  const female = _.get(_.find(genderJson.breakdown, ([gender]) => gender === 'female'), '[1].ageRange.sum');

  const male = _.get(_.find(genderJson.breakdown, ([gender]) => gender === 'male'), '[1].ageRange.sum');

  const sum = female + male;
  if (!sum) return null;
  return {
    female: 100 * (female / sum),
    male: 100 * (male / sum)
  };
}

function getAgeSeries(ageRange
/*: Object*/
)
/*: ?Array<{ category: string, activities: number }>*/
{
  const findBreakdown = key => {
    if (!ageRange) return null;
    if (!ageRange.breakdown) return null;
    const result = ageRange.breakdown.find(i => i[0] === key);
    if (!result) return 0;
    if (!result[1].gender) return 0;
    return result[1].gender.sum;
  };

  const ageSeries = [{
    category: '<25',
    activities: findBreakdown('under25')
  }, {
    category: '25-34',
    activities: findBreakdown('25to34')
  }, {
    category: '35-44',
    activities: findBreakdown('35to44')
  }, {
    category: '45-54',
    activities: findBreakdown('45to54')
  }, {
    category: '55-64',
    activities: findBreakdown('55to64')
  }, {
    category: '65+',
    activities: findBreakdown('65plus')
  }]; // If we don't have any activities, don't show anything

  if (!ageSeries.some(i => i.activities)) return null;

  const activitySum = _.reduce(ageSeries, (sum, {
    category,
    activities
  }) => sum + activities, 0);

  const normalizedAgeSeries = _.map(ageSeries, ({
    category,
    activities
  }) => ({
    category,
    percentage: 100 * (activities / activitySum)
  }));

  return normalizedAgeSeries;
}

function parseTimeSeries(data
/*: Object*/
)
/*: ?Array<timeElement>*/
{
  if (!data || !(data.intervals && data.intervals.length)) return null;
  return _.map(data.intervals, ({
    intervalStart,
    reach,
    response,
    action,
    activity,
    earned,
    used
  }) => ({
    timeStamp: new Date(intervalStart).valueOf(),
    reach: _.get(reach, 'events.sum', null),
    response: _.get(response, 'events.sum', null),
    action: _.get(action, 'events.sum', null),
    activity: _.get(activity, 'events.sum', null),
    earned: _.get(earned, 'events.sum', null),
    used: _.get(used, 'events.sum', null)
  }));
}

function parseRestrictions(data
/*: Object*/
)
/*: Restrictions*/
{
  if (!data) return {};
  return Restrictions.fromJson(data.restrictions);
}

module.exports = Stats;
/* Loyalty Stats Format
    response: [
      'Business Shared', 'Business Viewed',
      'Offer Viewed', 'Syndicated Offer Viewed',
      'Offer Bookmarked', 'Syndicated Offer Bookmarked',
      'Offer Shared', 'Syndicated Offer Shared',
      'Offer Card Swiped', 'Syndicated Offer Card Swiped'
    ],
    activity: [
      'Offer Punched', 'Syndicated Offer Punched'
    ],
    earned: [
      'Offer Punchcard Completed', 'Syndicated Offer Punchcard Completed'
    ],
    used: [
      'Offer Redeemed', 'Syndicated Offer Redeemed'
    ]
 */

/* Restrictions Format
    "restrictions": [
      {
        "name": "stats.feature.general.core.include_reach",
        "value": true,
        "group": "stats.feature.general.core"
      },
      {
        "name": "stats.feature.general.core.include_response",
        "value": true,
        "group": "stats.feature.general.core"
      },
      {
        "name": "stats.feature.general.core.include_action",
        "value": true,
        "group": "stats.feature.general.core"
      },
      {
        "name": "stats.feature.general.core.include_reach_demographic",
        "value": false,
        "group": "stats.feature.general.core"
      },
      {
        "name": "stats.feature.general.core.include_response_demographic",
        "value": false,
        "group": "stats.feature.general.core"
      },
      {
        "name": "stats.feature.general.core.include_action_demographic",
        "value": false,
        "group": "stats.feature.general.core"
      }
    ]
 */